import styled from 'styled-components'

export const Pagination = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 14px;

    h3#OficioBox_FixedTitle {
        margin: 0;
    }

    .MuiFormControl-root.MuiTextField-root {
        max-width: 90px;
    }

    input#outlined-basic {
        padding: 10px 14px;
    }

    .btn-action-pagination {
        background: var(--white);
        min-width: 0;
        padding: 0;
        width: 39px;
        height: 39px;
        border-radius: 100%;
        margin: 0 0 0 -4px;
    }

    span#skeleton-pagination {
        height: 39px;
        width: 250px;
        position: relative;
        transform: scale(1);
    }

    .MuiSkeleton-wave::after {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 250px;
    }

    .MuiSkeleton-wave::before {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 250px;
    }
`

Pagination.Controls = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 16px;
`